import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  addSubContractorAction,
  deleteSubContractorAction,
  getAllSubContractorAction,
  getSingleSubContractorAction,
  setAddSubContractorResponse,
  setAllSubContractorAction,
  setDeleteSubContractorResponse,
  setSingleSubContractorAction,
  setUpdateSubContractorLeadResponse,
  updateSubContractorLeadAction,
} from "../reducers/subContractor";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllSubContractorSaga(action: { payload: any }): any {
  const { page, limit, orderBy, orderIn } = action.payload;
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/subcontractors?page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}`
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(setAllSubContractorAction(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* addSubContractorSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/subcontractors"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSubContractorResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddSubContractorResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* getSingleSubContractorSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    // const {id} = payload;
    console.log("payload", payload);
    const { id, created_at, updated_at, ...newPayload } =
      payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/subcontractors/${id}`
    );

    if (apiResponse?.success === true) {
      //   apiResponse && handleSuccess(apiResponse);
      yield put(setSingleSubContractorAction(apiResponse?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* deleteSubContractorSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    // const {id} = payload;
    console.log("payload", payload);
    const { id, status, created_at, updated_at, ...newPayload } =
      payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/subcontractors/${id}`
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteSubContractorResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteSubContractorResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* updateSubContractorLeadSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const data = payload.payload[0]; // extract object from array
    const { id, ...newPayload } = data;
    const apiResponse = yield call<any>(
      callAPI,
      {payload:[newPayload]},
      "put",
      `leads/subcontractor/${id}`
    );
    console.log("updateSubContractorLead-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateSubContractorLeadResponse(true));
      yield put(setNotificationAction({ message: [], severity: "success" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateSubContractorLeadResponse(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchSubContractor() {
  yield takeLatest<any>(getAllSubContractorAction, getAllSubContractorSaga);
  yield takeLatest<any>(addSubContractorAction, addSubContractorSaga);
  yield takeLatest<any>(deleteSubContractorAction, deleteSubContractorSaga);
  yield takeLatest<any>(
    getSingleSubContractorAction,
    getSingleSubContractorSaga
  );
  yield takeLatest<any>(updateSubContractorLeadAction,updateSubContractorLeadSaga);
}
